import React, { Component, Fragment } from 'react'
import { useForm } from 'components/form/controller'
import { cls } from 'utilities/dom'
import { omit } from 'utilities/object'
import { Field, Control, Label } from 'components/form/field/s'
import Select from 'components/form/input/select'
import { empty } from './utilities'

class EditSelect extends Component {
    constructor(props) {
        super(props)

        this.state = this.valueStateFromProps(props)
        this.register()
    }

    componentDidMount() {
        const { include = 'touched' } = this.props.field
        if(include !== 'never') {
            this.props.form.triggerChange(this.props.name, { touched: false })
        }
    }

    componentDidUpdate = ({ name, field, whistle }, { value }) => {
        const nameChanged = name !== this.props.name
        const valueChanged = value !== this.state.value
        const requiredChanged = field?.required !== this.props.field?.required
        const includeChanged = field?.include !== this.props.field?.include
        const whistleReceived = whistle !== this.props.whistle

        if(this.props.field?.include !== 'never' && nameChanged) {
            this.props.form.unregisterField(name)
            this.register()
        }

        if(requiredChanged || includeChanged) {
            this.register(true)
        }

        if(this.props.field?.include !== 'never' && valueChanged) {
            this.props.form.triggerChange(this.props.name)
        }

        if(whistleReceived) {
            this.setState(this.valueStateFromProps())
        }
    }

    componentWillUnmount() {
        const { include = 'touched' } = this.props.field
        if(include !== 'never') {
            this.props.form.unregisterField(this.props.name)
        }
    }

    register = (update = false) => {
        let {
            required = false,
            include = 'touched'
        } = this.props.field ?? {}

        if(include === 'never') {
            return
        }

        this.props.form.registerField(this.props.name, {
            type: 'select',

            empty: empty.value,
            required,
            include,

            unset: this.unset,

            validator: value => {
                if(!value && value !== 0) {
                    value = empty.value
                }

                return required ?
                    !!this.props.options
                        .filter(option => !option.disabled)
                        .find(option => `${option.value}` === `${value}`) :
                    true
            }
        }, update)
    }

    valueStateFromProps = (props = this.props) => ({
        value: props.field?.value || empty.value
    })

    unset = () => this.setState({ value: empty })

    onChange = ({ target: { value } }) => {
        this.setState({ value })
        this.props.onChange?.({ [this.props.name]: value })
    }

    render() {
        const { value } = this.state

        const {
            className,
            field = {},
            controlProps = {},
            salt,
            label,
            optgroupLabel = null,
            name,
            options,
            enabled = true,
            loading = false,
            traditional = false,
            error: outsideError,
            forwardedRef,
            ...props
        } = this.props

        const {
            allowEmptyOption = true,
            unsetText = empty?.text ?? '',
            required,
            softRequired,
            optional
        } = field

        const touched = this.props.form.touched.includes(name)
        const internalError = (name in this.props.form.errors) && touched
        const error = internalError || !!outsideError

        const fieldClassName = cls([
            className,
            touched && 'touched',
            (!error && loading) && 'loading',
            error && 'error'
        ])

        const isEmptyAndDisabled = [
            !allowEmptyOption,
            value === empty.value,
            options.find(({ value }) => value === empty.value)?.disabled
        ].every(Boolean)

        const controlClassName = cls([
            controlProps.className,
            traditional && 'traditional',
            isEmptyAndDisabled && 'empty'
        ])

        const Optgroup = optgroupLabel ?
            'optgroup' :
            Fragment

        return (
            <Field {...(fieldClassName ? { className: fieldClassName } : null)}>
                {!!label && (
                    <Label
                        htmlFor={salt}
                        required={required || softRequired}
                        optional={optional}>
                        {label}
                    </Label>
                )}
                <Control {...(!!error ? { className: 'error' } : null)}>
                    <Select
                        {...controlProps}
                        {...(controlClassName ? { className: controlClassName } : null)}
                        {...omit(props, 'form', 'whistle')}
                        name={name}
                        id={salt}
                        value={value ?? (allowEmptyOption ? empty?.value : options[0].value)}
                        onChange={this.onChange}
                        disabled={!enabled}
                        ref={forwardedRef}>
                        {!!allowEmptyOption && (
                            <option value={empty?.value}>
                                {unsetText}
                            </option>
                        )}
                        <Optgroup {...(optgroupLabel ? { label: optgroupLabel } : null)}>
                            {options.map(({ key, text, ...option }) => (
                                <option
                                    {...option}
                                    key={`${salt}:option:${key}:selected:${value === option.value}`}>
                                    {text || option.value}
                                </option>
                            ))}
                        </Optgroup>
                    </Select>
                </Control>
            </Field>
        )
    }
}

export default props => {
    const form = useForm()

    return (
        <EditSelect
            {...props}
            form={form} />
    )
}